import type { PropsWithChildren, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import MuiListItem, {
  type ListItemProps as MuiListItemProps,
} from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { isString } from '@witmetrics/utils/strings';
import { classes } from './utils';

export interface ListItemProps extends PropsWithChildren {
  sx?: MuiListItemProps['sx'];
  className?: string;
  alignItems?: MuiListItemProps['alignItems'];
  label: string | ReactNode;
  actions?: ReactNode;
  onClick?: () => void;
}

export default function ListItem({
  sx,
  className,
  alignItems,
  label,
  actions,
  onClick,
}: ListItemProps) {
  return (
    <MuiListItem
      sx={sx}
      className={twMerge(classes.item, className)}
      alignItems={alignItems}
      secondaryAction={actions}
      onClick={onClick}>
      {isString(label) ? (
        <ListItemText className={classes.text} primary={label} />
      ) : (
        label
      )}
    </MuiListItem>
  );
}
